'use client';

import PageError from '@/components/error/page-error';
import SendToSentry from '@/components/send-to-sentry';

export default function Error({
  error,
  // reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {

  const errorCode =
    error.message === 'NETWORK ERROR' || error.cause === 'NETWORK ERROR'
      ? 503
      : 500;
  const errorDetails =
    errorCode === 503
      ? 'There may be a problem with the connection.'
      : 'Something went wrong.';
  return (
    <>
      <PageError
        showContactSupport={errorCode >= 500}
        statusCode={errorCode}
        statusMessage="Oops!"
        details={errorDetails}
      />
      <SendToSentry error={error} />
    </>
  );
}
